import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Cookies from 'js-cookie';

import { COOKIE_KEY_CHAT_COMPANY_ID } from '../../const/AppConst';

import RatingView from './pages/RatingView';
import QvRatingView from './pages/qv/QvRatingView';
import DaishinRatingView from './pages/daishin/DaishinRatingView';
import HyundairsRatingView from './pages/hyundairs/HyundairsRatingView';

@observer
class RatingRouter extends Component {
  render() {
    const chatCompID = Cookies.get(COOKIE_KEY_CHAT_COMPANY_ID);

    if (chatCompID === '15') return <QvRatingView {...this.props} />;

    if (chatCompID === '17') return <DaishinRatingView {...this.props} />;

    if (chatCompID === '35') return <HyundairsRatingView {...this.props} />;

    return <RatingView {...this.props} />;
  }
}

export default RatingRouter;
